import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { isEmpty, orderBy } from "lodash"

import HistoryTable from "./HistoryTable/HistoryTable"
import NoHistory from "./NoHistory"

import styles from "./History.css"

const HistoryComponent = ({ title, awaitingUpdateMessage, history, help }) => (
  <Fragment>
    {title && (
      <div className={styles.header}>
        {title}
        {" "}
        {help && <span className="zmdi zmdi-help-outline inlineBlock v-m" data-tip={help} />}
      </div>
    )}
    {isEmpty(history) ? <NoHistory /> : (
      <HistoryTable
        awaitingUpdateMessage={awaitingUpdateMessage}
        history={orderBy(history, item => item.occurrence_datetime.timestamp, ["desc"])}
      />
    )}
  </Fragment>
)

HistoryComponent.propTypes = {
  title: PropTypes.node,
  awaitingUpdateMessage: PropTypes.string,
  history: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    location: PropTypes.string,
    occurrence_datetime: PropTypes.shape({
      iso: PropTypes.string.isRequired,
      timestamp: PropTypes.number.isRequired,
    }),
    status: PropTypes.string,
  })).isRequired,
  help: PropTypes.string,
}

HistoryComponent.defaultProps = {
  title: null,
  awaitingUpdateMessage: null,
  help: null,
}

export default HistoryComponent



// WEBPACK FOOTER //
// ./src/views/Parcel/components/History/History.js